// src/pages/Admin/AdminCases.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { casesAPI } from '../../api/cases.js';
import { useToast } from '../../hooks/useToast.js';
import { Button } from '../../components/ui/Button/Button.jsx';
import { Loader } from '../../components/ui/Loader/Loader.jsx';

export const AdminCases = () => {
  const [cases, setCases] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { success, error } = useToast();

  useEffect(() => {
    loadCases();
  }, []);

  const loadCases = async () => {
    setIsLoading(true);
    try {
      const response = await casesAPI.getAll({ limit: 50 });
      setCases(response.data.data || []);
    } catch (err) {
      error('Не удалось загрузить кейсы');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Вы уверены?')) return;
    try {
      await casesAPI.delete(id);
      success('Кейс удален');
      loadCases();
    } catch (err) {
      error('Не удалось удалить кейс');
    }
  };

  if (isLoading) {
    return <Loader text="Загрузка кейсов..." />;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h2>Кейсы</h2>
        <Link to="/admin/cases/new">
          <Button>+ Новый кейс</Button>
        </Link>
      </div>

      <div style={{
        backgroundColor: 'rgb(var(--c-surface))',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <thead>
              <tr style={{ backgroundColor: 'rgb(var(--c-bg))' }}>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Название</th>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Клиент</th>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Категория</th>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Статус</th>
                <th style={{ padding: '12px 16px', textAlign: 'right' }}>Действия</th>
              </tr>
            </thead>
            <tbody>
              {cases.map((caseItem) => (
                <tr key={caseItem.id} style={{ borderTop: '1px solid rgb(var(--c-surface-2))' }}>
                  <td style={{ padding: '12px 16px' }}>
                    <Link to={`/admin/cases/${caseItem.id}`} style={{ color: 'rgb(var(--c-text))', textDecoration: 'none' }}>
                      {caseItem.title}
                    </Link>
                  </td>
                  <td style={{ padding: '12px 16px', color: 'rgb(var(--c-text-secondary))' }}>{caseItem.client}</td>
                  <td style={{ padding: '12px 16px', color: 'rgb(var(--c-text-secondary))' }}>{caseItem.category}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{
                      padding: '2px 10px',
                      borderRadius: '100px',
                      fontSize: '12px',
                      fontWeight: 500,
                      backgroundColor: caseItem.is_completed ? '#D4EDDA' : '#FFF3CD',
                      color: caseItem.is_completed ? '#155724' : '#856404',
                    }}>
                      {caseItem.is_completed ? 'Завершен' : 'В процессе'}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                      <Link to={`/admin/cases/${caseItem.id}`}>
                        <button style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: 'rgb(var(--c-accent))' }}>✏️</button>
                      </Link>
                      <button onClick={() => handleDelete(caseItem.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: 'rgb(var(--c-danger))' }}>🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};